import { toast } from "sonner";

export const showSuccess = (title, description) =>
  toast.success(title, { description });

export const showError = (title, description) =>
  toast.error(title, { description });

export const showWarning = (title, description) =>
  toast.warning(title, { description });

export const showInfo = (title, description) =>
  toast.info(title, { description });
